export const serialize = function(obj) {
  var str = [];
  for (var p in obj) {
    str.push(p + "=" + obj[p]);
  }
  return str.join("&");
};
